export const money = (value: number) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);

export const dateTime = (value: string) =>
  new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));

export const onlyDigits = (value: string) => value.replace(/\D/g, "");

export const phoneMask = (value: string) => {
  const digits = onlyDigits(value).slice(0, 11);
  if (digits.length <= 10)
    return digits.replace(/(\d{2})(\d{0,4})(\d{0,4})/, "($1) $2-$3").replace(/-$/, "");
  return digits
    .replace(/(\d{2})(\d{0,5})(\d{0,4})/, "($1) $2-$3")
    .replace(/-$/, "");
};

export const statusLabel: Record<string, string> = {
  awaiting_payment: "Aguardando Pix",
  received: "Recebido",
  preparing: "Em preparo",
  ready: "Pronto",
  out_for_delivery: "Saiu para entrega",
  delivered: "Entregue",
  cancelled: "Cancelado",
};

export const paymentLabel: Record<string, string> = {
  pix: "Pix",
  cash: "Dinheiro",
  credit: "Crédito na entrega",
  debit: "Débito na entrega",
  counter: "Pagamento no balcão",
};
